import { atom } from "recoil";
import { ISecurityDetails, ISecurityInfo } from "../types";

export const alarmDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  vendorId: 0,
  vendor: "",
  vendorPhone: "",
  contractRenewalDate: null,
  accountNumber: "",
  alarmSiteNumber: "",
  dataConnection: "",
  dataConnectionId: 0,
  connectionDetails: "",
  alarmTypeId: 0,
  alarmType: "",
  numberOfMotionSensors: "",
  numberOfDoorContacts: "",
  numberOfPanicButtons: "",
  specialEquipment: "",
  alarmInstallDate: "",
  isActive: false,
};
export const cameraDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  camerasAndLocation: "",
  camerasAndLocationIds: "",
  cameraType1: "",
  cameraType1Id: 0,
  cameraType2: "",
  cameraType2Id: 0,
  cameraMake: "",
  cameraModel: "",
  dvrType: "",
  dvrtypeId: 0,
  dvrrecordingMax: "",
  cameraSystem: "",
  cameraSystemId: 0,
  cameraInstallDate: "",
  isActive: false,
  cameraModalState: false,
};
export const safeDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  safeType: "",
  safeTypeId: 0,
  isSafeBolted: "",
  safeCode: "",
  safeMake: "",
  safeModel: "",
  safeSerialNumber: "",
  safeLocation: "",
  safeMakeId: 0,
  isActive: false,
};
export const doorBuzzerDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  siteNumber: 0,
  connection: "",
  installDate: "",
  type: "",
  numberOfButtonSelected: "",
  warranty: "",
  warrantyLength: "",
  warrantyCoverage: "",
  warrantyCoverageId: 0,
  typeOfVendor: "",
  typeOfVendorId: 0,
  dbinstallendorName: "",
  dbinstallVendorId: 0,
  dbinstallVendorAddress: "",
  dbinstallVendorPhone: "",
  dbservicingVendorId: 0,
  dbservicingVendorName: "",
  dbservicingVendorAddress: "",
  dbservicingVendorPhone: "",
  dbservicingVendorContact: "",
  dbwarrantyVendorId: 0,
  dbwarrantyVendorName: "",
  dbwarrantyVendorAddress: "",
  dbwarrantyVendorPhone: "",
  dbwarrantyVendorContact: "",
  contact: "",
  isActive: false,
};
export const officeKeysDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  lockSmithVendor: "",
  lockSmithVendorId: 0,
  okvendorAddress: "",
  okvendorPhone: "",
  numberOfKeys: "",
  keysAssignedTo: "",
  keysAssignedIds: "",
  keyCodingModel: "",
  isActive: false,
};
export const hvacDefault = {
  parentRow: false,
  tableName: "",
  id: 0,
  recordNumber: 0,
  numberOfUnits: "",
  unitType: "",
  tonCapacity: "",
  hvacinstallDate: "",
  preventiveMaintenancePlan: "",
  maintenanceCompany: "",
  maintenanceCompanyId: 0,
  isActive: false,
};

export const securityDefaultDetails = {
  recordNumber: null,
  officeId: 0,
  office: "",
  officeState: "",
  officeBrand: "",
  officeStatus: "",

  fileCatergoryId: 0,
  fileCategory: "",
  fileName: "",
  createdBy: "",
  createdDate: "",
  modifiedBy: "",
  modifiedDate: "",
  attachments: [],
  attachmentsForDelete: [],
  fileNames: [],

  alarmArray: [],
  cameraArray: [],
  safeArr: [],
  doorBuzzerArr: [],
  officeKeysArr: [],
  hvacArr: [],
};

export const SecurityShowState = atom({
  key: "SecurityShowState",
  default: false,
});

export const setLinkStateSecurity = atom({
  key: "setLinkStateSecurity",
  default: false,
});

export const SecurityAddState = atom({
  key: "SecurityAddState",
  default: false,
});

export const SecurityEditState = atom({
  key: "SecurityEditState",
  default: false,
});

export const securityFromOffice = atom({
  key: "securityFromOffice",
  default: false,
});

export const rowForEditSecurity = atom<ISecurityDetails | undefined>({
  key: "rowForEditSecurity",
  default: undefined,
});
// export const rowForAlarmEdit = atom<IAlarm>({
//   key: "rowForAlarmEdit",
//   default: alarmDefault,
// });

export const securityAddButton = atom({
  key: "securityAddButton",
  default: false,
});

// export const unknownCheckBox = atom({
//   key: "unknownCheckBox",
//   default: true,
// });

// export const fullPayCheckBox = atom({
//   key: "fullPayCheckBox",
//   default: true,
// });

export const securitySearchData = atom({
  key: "securitySearchData",
  default: {
    RecordNumber: "",
    OfficeId: null,
    OfficeStatus: "",
    OfficeBrand: "",
    OfficeBrandName: "",
    OfficeState: "",
  },
});

export const SecuritySaving = atom({
  key: "SecuritySaving",
  default: false,
});

export const attachDisplay = atom({
  key: "attachDisplay",
  default: [],
});

export const securityAttachments = atom<(File | null)[]>({
  key: "securityAttachments",
  default: [null],
});

export const securityOnchangeCategory = atom<any>({
  key: "securityOnchangeCategory",
  default: [],
});

export const removeFileCategory = atom({
  key: "removeFileCategory",
  default: [],
});

export const securityAttachmentsForDelete = atom({
  key: "securityAttachmentsForDelete",
  default: [],
});

export const securityViewData = atom({
  key: "securityViewData",
  default: undefined,
});

export const securityOfficeId = atom({
  key: "securitytOfficeId",
  default: undefined,
});

export const AlarmModalState = atom({
  key: "AlarmModalState",
  default: false,
});

export const CardReaderModalState = atom({
  key: "CardReaderModalState",
  default: false,
});

export const FireAlarmSystemModalState = atom({
  key: "FireAlarmSystemModalState",
  default: false,
});
export const CameraModalState = atom({
  key: "CameraModalState",
  default: false,
});

export const CardReaderState = atom({
  key: "CardReaderState",
  default: false,
});

export const OfficeEditSecurity = atom({
  key: "OfficeEditSecurity",
  default: false,
});

export const SafeModalState = atom({
  key: "SafeModalState",
  default: false,
});

export const officeKeyModalState = atom({
  key: "officeKeyModalState",
  default: false,
});
export const DoorBuzzerModalState = atom({
  key: "DoorBuzzerModalState",
  default: false,
});
export const HvacModalState = atom({
  key: "HvacModalState",
  default: false,
});

export const AlarmAddState = atom({
  key: "ALarmAddState",
  default: false,
});

export const FireAlarmSystemAddState = atom({
  key: "FireAlarmSystemAddState",
  default: false,
});

export const AlarmForEdit = atom({
  key: "AlarmForEdit",
  default: false,
});

export const CardReaderAddState = atom({
  key: "CardReaderAddState",
  default: false,
});

export const CardReaderForEdit = atom({
  key: "CardReaderForEdit",
  default: false,
});

export const FireAlarmSystemForEdit = atom({
  key: "FireAlarmSystemForEdit",
  default: false,
});

export const AlarmSaving = atom({
  key: "AlarmSaving",
  default: false,
});

export const FireAlarmSystemSaving = atom({
  key: "FireAlarmSystemSaving",
  default: false,
});

export const CardReaderSaving = atom({
  key: "CardReaderSaving",
  default: false,
});

export const CameraAddState = atom({
  key: "CameraAddState",
  default: false,
});

export const CameraForEdit = atom({
  key: "CameraForEdit",
  default: false,
});

export const CameraSaving = atom({
  key: "CameraSaving",
  default: false,
});

export const SafeAddState = atom({
  key: "SafeAddState",
  default: false,
});

export const SafeForEdit = atom({
  key: "SafeForEdit",
  default: undefined,
});

export const SafeSaving = atom({
  key: "SafeSaving",
  default: false,
});

export const DoorBuzzerAddState = atom({
  key: "DoorBuzzerAddState",
  default: false,
});

export const DoorBuzzerForEdit = atom({
  key: "DoorBuzzerForEdit",
  default: false,
});

export const DoorBuzzerSaving = atom({
  key: "DoorBuzzerSaving",
  default: false,
});
export const officeKeysAddState = atom({
  key: "officeKeysAddState",
  default: false,
});

export const OfficeKeysForEdit = atom({
  key: "OfficeKeysForEdit",
  default: false,
});

export const officeKeysSaving = atom({
  key: "officeKeysSaving",
  default: false,
});
export const HvacAddState = atom({
  key: "HvacAddState",
  default: false,
});

export const HvacForEdit = atom({
  key: "HvacForEdit",
  default: undefined,
});

export const HvacSaving = atom({
  key: "HvacSaving",
  default: false,
});

export const SecurityEditStateFromOffice = atom({
  key: "SecurityEditStateFromOffice",
  default: false,
});
export const SecurityEditDataFromOffice = atom({
  key: "SecurityEditDataFromOffice",
  default: undefined,
});
export const disableSecOfficeField = atom({
  key: "disableSecOfficeField",
  default: false,
});

export const securityOfficeState = atom({
  key: "securityOfficeState",
  default: undefined,
});

export const securityOfficeBrand = atom({
  key: "securityOfficeBrand",
  default: undefined,
});

export const securityOfficeStatus = atom({
  key: "securityOfficeStatus",
  default: undefined,
});

export const selectedRowsSecurity = atom({
  key: "selectedRowsSecurity",
  default: undefined,
});

export const controlFields = atom({
  key: "controlFields",
  default: [],
});

export const alarmDeactivateModal = atom({
  key: "alarmDeactivateModal",
  default: false,
});

export const cameraDeactivateModal = atom({
  key: "cameraDeactivateModal",
  default: false,
});

export const cardReaderDeactivateModal = atom({
  key: "cardReaderDeactivateModal",
  default: false,
});

export const FireAlarmSystemDeactivateModal = atom({
  key: "FireAlarmSystemDeactivateModal",
  default: false,
});

export const safeDeactivateModal = atom({
  key: "safeDeactivateModal",
  default: false,
});

export const hvacDeactivateModal = atom({
  key: "hvacDeactivateModal",
  default: false,
});

export const okDeactivateModal = atom({
  key: "okDeactivateModal",
  default: false,
});

export const dbDeactivateModal = atom({
  key: "dbDeactivateModal",
  default: false,
});

// export const addCardReaderForm = atom({
//   key: "addCardReaderForm",
//   default: {
//     RecordNumber: "",

//     siteAdmins: [
//       {
//         employeeId: 0,
//         email: "",
//         isFieldsDisabled: false,
//         isMasterAdmin: false,
//         name: "",
//         phoneNumber: "",
//       },
//     ],
//     masterAdmin: [
//       {
//         employeeId: 0,
//         email: "",
//         isFieldsDisabled: false,
//         isMasterAdmin: true,
//         name: "",
//         phoneNumber: "",
//       },
//     ],
//     groupInfos: [
//       {
//         daysOftheWeek: "",
//         daysOftheWeekArr: null,
//         doors: [""],
//         endTime: "",
//         startTime: "",
//         groupTitle: "",
//         staffGroup: "",
//       },
//     ],
//     accountNumberBrivo: "",
//     accountNumberBilling: "",
//     vendorPhone: "",
//     vendorCS: "",
//     brivoSiteNumber: "",
//     confieSiteNumber: "",
//     dataConnectionEquipment: "",
//     dataConnectionPort: "",
//     ipAddress: "",
//     installDate: "",
//     cancelationDate: "",
//     warrantyCoverage: "",
//     additionalDescription: "",
//     coverageStartDate: "",
//     coverageEndDate: "",
//     cardType: "",
//     parkingCardFormat: "",
//     parkingSiteNumber: "",
//     cardName: "",
//     cardCompanyName: "",
//     cardAddress: "",
//     cardHours: "",
//     cardEmailAddress: "",
//     vendorId: 0,
//     ipAddressSettingOption: null,
//     isWarranty: false,
//     isKeyCardAccess: false,
//   },
// });

export type SiteAdmin = {
  employeeId: number;
  email: string;
  isFieldsDisabled: boolean;
  isMasterAdmin: boolean;
  name: string;
  phoneNumber: string;
};

export type GroupInfo = {
  daysOftheWeek: string;
  daysOftheWeekArr: string[] | null;
  doors: string[];
  endTime: string;
  startTime: string;
  groupTitle: string;
  staffGroup: string;

  mondayStartTime: string;
  mondayEndTime: string;

  tuesdayStartTime: string;
  tuesdayEndTime: string;

  wednesdayStartTime: string;
  wednesdayEndTime: string;

  thursdayStartTime: string;
  thursdayEndTime: string;

  fridayStartTime: string;
  fridayEndTime: string;

  saturdayStartTime: string;
  saturdayEndTime: string;

  sundayStartTime: string;
  sundayEndTime: string;

  monday_Hours: string;
  tuesday_Hours: string;
  wednesday_Hours: string;
  thursday_Hours: string;
  friday_Hours: string;
  saturday_Hours: string;
  sunday_Hours: string;
};

export type CardReaderForm = {
  id?: number;
  RecordNumber: string;
  siteAdmins: SiteAdmin[];
  masterAdmin: SiteAdmin[];
  groupInfos: GroupInfo[];
  accountNumberBrivo: string;
  accountNumberBilling: string;
  vendorPhone: string;
  vendorCS: string;
  brivoSiteNumber: string;
  confieSiteNumber: string;
  dataConnectionEquipment: string;
  dataConnectionPort: string;
  ipAddress: string;
  installDate: string;
  cancelationDate: string;
  warrantyCoverage: string;
  additionalDescription: string;
  coverageStartDate: string;
  coverageEndDate: string;
  cardType: string;
  parkingCardFormat: string;
  parkingSiteNumber: string;
  cardName: string;
  cardCompanyName: string;
  cardAddress: string;
  cardHours: string;
  cardEmailAddress: string;
  vendorId: number;
  ipAddressSettingOption: string | null;
  isWarranty: boolean;
  isKeyCardAccess: boolean;
};

export const emptyCardReader = {
  RecordNumber: "",
  siteAdmins: [
    {
      employeeId: 0,
      email: "",
      isFieldsDisabled: false,
      isMasterAdmin: false,
      name: "",
      phoneNumber: "",
    },
  ],
  masterAdmin: [
    {
      employeeId: 0,
      email: "",
      isFieldsDisabled: false,
      isMasterAdmin: true,
      name: "",
      phoneNumber: "",
    },
  ],
  groupInfos: [
    {
      daysOftheWeek: "",
      daysOftheWeekArr: null,
      doors: [""],
      endTime: "",
      startTime: "",
      groupTitle: "",
      staffGroup: "",

      mondayStartTime: "",
      mondayEndTime: "",

      tuesdayStartTime: "",
      tuesdayEndTime: "",

      wednesdayStartTime: "",
      wednesdayEndTime: "",

      thursdayStartTime: "",
      thursdayEndTime: "",

      fridayStartTime: "",
      fridayEndTime: "",

      saturdayStartTime: "",
      saturdayEndTime: "",

      sundayStartTime: "",
      sundayEndTime: "",
    },
  ],
  accountNumberBrivo: "",
  accountNumberBilling: "",
  vendorPhone: "",
  vendorCS: "",
  brivoSiteNumber: "",
  confieSiteNumber: "",
  dataConnectionEquipment: "",
  dataConnectionPort: "",
  ipAddress: "",
  installDate: "",
  cancelationDate: "",
  warrantyCoverage: "",
  additionalDescription: "",
  coverageStartDate: "",
  coverageEndDate: "",
  cardType: "",
  parkingCardFormat: "",
  parkingSiteNumber: "",
  cardName: "",
  cardCompanyName: "",
  cardAddress: "",
  cardHours: "",
  cardEmailAddress: "",
  vendorId: 0,
  ipAddressSettingOption: null,
  isWarranty: false,
  isKeyCardAccess: false,
};
export const addCardReaderForm = atom<CardReaderForm[]>({
  key: "addCardReaderForm",
  default: [],
});

export enum ActionType {
  ADD = "Add Card Reader",
  EDIT = "Edit Card Reader ",
  DELETE = "DELETE",
  NONE = "NONE",
  UPDATE = "Update Initial Add CardReader",
}

export const cardReaderFormState = atom<ActionType>({
  key: "cardReaderFormState",
  default: ActionType.NONE,
});

export const cardReaderDatas = atom({
  key: "cardReaderDatas",
  default: null,
});

export const recordNumberForEdit = atom({
  key: "recordNumberForEdit",
  default: null,
});

export const initialSecurityActions = atom<"ADD" | "EDIT" | null>({
  key: "initialSecurityActions",
  default: null,
});

export const addedCardReader = atom<CardReaderForm[]>({
  key: "addedCardReader",
  default: [],
});

export const updatedCardReader = atom<CardReaderForm[]>({
  key: "updatedCardReader",
  default: [],
});

export const cardReaderEditIndexState = atom<number | null>({
  key: "cardReaderEditIndexState",
  default: null,
});

export const cardReaderEditDatas = atom({
  key: "cardReaderEditDatas",
  default: null,
});

//Camera recoil

export interface TempCamera {
  cameraMake: string;
  cameraModel: string;
  dvrTypeId: number | null;
  dvrRecordingMax: string | null;
  cameraInstallDate: string | null;
  isActive: boolean;
  cameraSystemId: number | null;
  cameraLocationsDto: {
    id: number;
    cameraId: number;
    camerasAndLocationId: string;
    cameraType1: number | null;
    cameraType2: number | null;
  }[];
}

export const tempCameras = atom<TempCamera[]>({
  key: "tempCameras",
  default: [],
});

export interface TempAlarm {
  vendorId: number | null;
  vendorName: string;
  vendorPhone: string;
  contractRenewalDate?: string | null;
  accountNumber: string;
  alarmSiteNumber: string;
  dataConnection: string;
  dataConnectionId: number | null;
  connectionDetails: string;
  alarmTypeId: number;
  alarmTypeName: string;
  numberOfMotionSensors: string;
  numberOfDoorContacts: string;
  numberOfPanicButtons: string;
  specialEquipment: string;
  alarmInstallDate: string;
  cancellationDate: string;

  isActive: boolean;
  ipaddress: string;
  portNumber: string;
  ipGateway: string;
  subnetMask: string;
  dns: string;
}

export interface TempFireAlarmSystem {
  recordNumber: number | null;
  fireAlarmSystemId?: number | null;
  vendorId: number | null;
  vendorName?: string;
  vendorPhone: string;
  vendorAccountNumber: string;
  siteNumber: string;
  dataConnection?: string;
  dataConnectionId: number | null;
  connectionDetails: string;
  fireAlarmTypeId: number;
  alarmTypeName?: string;
  numberOfFireAlarmSensorsId: string;
  numberOfFloorsId: string;
  specialEquipment: string;
  installDate: string;
  isActive?: boolean;
  ipaddress: string;
  ipGateway: string | null;
  subnetMask: string | null;
  dns: string | null;
  portNumber: string;
  phoneConnection: string | null;
  cancellationDate: string | null;
  createdBy?: string | null;
  createdDate?: string | null;
  modifiedBy?: string | null;
  modifiedDate?: string | null;
}

export const tempAlarms = atom<TempAlarm[]>({
  key: "tempAlarms",
  default: [],
});

export const tempFireAlarmSystems = atom<TempFireAlarmSystem[]>({
  key: "tempFireAlarmSystems",
  default: [],
});

export const CameraForEditFromOffice = atom({
  key: "CameraForEditFromOffice",
  default: false,
});

export const RequiredInput = atom({
  key: "RequiredInput",
  default: false,
});
